import { useRemoteConfig } from 'core/hooks/use-remote-config';

/**
 * Тёмная тема воронки включена: theme = {"mode": "dark"} в remote config.
 * Нужен там, где цвет нельзя отдать css — например при выборе картинки
 * (см. токены темы в src/styles/theme.scss).
 */
export const useIsDarkTheme = (): boolean => useRemoteConfig().theme?.mode === 'dark';
